<template lang="pug">
.lobby
  .content
    .lobby-text
      //p.header.typing-demo.type-lobby Lobby
      //p.desc.typing-demo(
         :style="{ width: 30 + lobbyId.length + 'ch', 'animation-timing-function': 'steps(' + (30 + lobbyId.length) + ')' }"
        ) Paste this ID to your friend: {{ lobbyId }}
      p.header Lobby
      p.desc Paste this ID to your friend: {{ lobbyId }}
    .main-container
      .red-container
        .team-header
          p.typing-demo.type-red-team Red Team
        .team-member(
          v-for="(aPlayer, index) in redTeamPlayers",
          :key="'red-' + index"
        )
          p.typing-demo(
            :style="{ width: aPlayer.name.length + 'ch', 'animation-timing-function': 'steps(' + aPlayer.name.length + ')' }"
          ) {{ aPlayer.name }}
          span.you(v-if="aPlayer.id === playerId") (You)
          .ready-check(v-if="aPlayer.isReady")
            img(src="../assets/check.svg")

      .middle-container
        .game-header
          p.typing-demo.type-codenames CodeNames
        .input-main-container(v-if="canEditName")
          .input-header
            p.typing-demo Agent Name:
          .input-container
            input#name-input(
              @keyup.enter="submitName",
              v-model="username",
              maxlength="20"
            )
            .floating-text
              p [Enter]
        .ready-container(v-if="!canEditName && !isReady")
          .select-team
            .select-red-team(@click="joinRed")
              p.typing-demo.type-join-red
                | Join Red
            .select-blue-team(@click="joinBlue")
              p.typing-demo.type-join-blue
                | Join Blue
          .ready(@click="ready")
            p.typing-demo.type-ready Ready
        .cancel-ready-container(v-if="isReady")
          .cancel-ready(@click="cancelReady")
            p.typing-demo.type-cancel Cancel
        .error-msg(v-if="errorMsg")
          p {{ errorMsg }}
        .start-container(
          @mouseover="hover",
          @mouseleave="stopHover",
          @click="start",
          :class="{ 'has-hover': isReady }"
        )
          img(src="../assets/assassin.png")
          .start-text(v-if="!canEditName && isReady")
            p.typing-demo.type-start Start

      .blue-container
        .team-header
          p.typing-demo.type-blue-team Blue Team
        .team-member(
          v-for="(aPlayer, index) in blueTeamPlayers",
          :key="'blue-' + index"
        )
          p.typing-demo(
            :style="{ width: aPlayer.name.length + 'ch', 'animation-timing-function': 'steps(' + aPlayer.name.length + ')' }"
          ) {{ aPlayer.name }}
          span.you(v-if="aPlayer.id === playerId") (You)
          .ready-check(v-if="aPlayer.isReady")
            img(src="../assets/check.svg")
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { nanoid } from "nanoid";
import axios from "axios";
import animateWrite from "../helper/typewriter";
export default {
  name: "Lobby",
  components: {},
  data() {
    return {
      showBg: false,
      canEditName: true,
      username: "",
      errorMsg: "",
      lobbyId: "",
      playerId: "",
      gameId: "",
      isReady: false,
      playerIdListeners: [],
      gameIdListener: {
        ref: {},
        listener: {},
      },
      playersListener: {
        ref: {},
        listener: {},
      },
      typewriter: {
        lobby: {
          data: "Lobby",
          display: "",
          charIndex: 0,
        },
        redTeam: {
          data: "Red Team",
          display: "",
          charIndex: 0,
        },
        codeNames: {
          data: "CodeNames",
          display: "",
          charIndex: 0,
        },
        agentName: {
          data: "Agent Name:",
          display: "",
          charIndex: 0,
        },
        blueTeam: {
          data: "Blue Team",
          display: "",
          charIndex: 0,
        },
      },
    };
  },
  computed: {
    allReady() {
      let ok = true;
      this.players.forEach((player) => {
        if (!player.isReady) {
          ok = false;
        }
      });
      return ok;
    },
    players() {
      return this.$store.state.players;
    },
    redTeamPlayers() {
      return this.players.filter((x) => x.team === "red");
    },
    blueTeamPlayers() {
      return this.players.filter((x) => x.team === "blue");
    },
  },
  methods: {
    ready() {
      this.isReady = true;
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" + this.lobbyId + "/players/" + this.playerId + "/isReady";
      updates[query] = true;
      db.ref().update(updates);
    },
    cancelReady() {
      this.isReady = false;
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" + this.lobbyId + "/players/" + this.playerId + "/isReady";
      updates[query] = false;
      db.ref().update(updates);
    },
    joinRed() {
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" + this.lobbyId + "/players/" + this.playerId + "/team";
      updates[query] = "red";
      db.ref().update(updates);
    },
    joinBlue() {
      const db = this.$store.state.db;
      const updates = {};
      const query =
        "/lobby/" + this.lobbyId + "/players/" + this.playerId + "/team";
      updates[query] = "blue";
      db.ref().update(updates);
    },
    hover() {
      this.showBg = true;
    },
    stopHover() {
      this.showBg = false;
    },
    submitName() {
      const ok = this.validateUsername();
      if (ok) {
        this.canEditName = false;
        const db = this.$store.state.db;
        const player = {
          id: this.playerId,
          name: this.username,
          isReady: false,
        };
        let team;
        const players = this.$store.state.players;

        if (players.length % 2 === 0) {
          team = "red";
        } else {
          team = "blue";
        }

        const updates = {};
        updates["lobby/" + this.lobbyId + "/players/" + player.id] = {
          id: player.id,
          name: player.name,
          team,
          isReady: false,
          isSpyMaster: false,
        };
        db.ref().update(updates);
      }
    },

    /*
     * Check valid username.
     */
    validateUsername() {
      this.errorMsg = "";
      let ok = true;

      // No empty name
      if (this.username === "") {
        this.errorMsg = "No empty names !";
        ok = false;
      }

      // No blank whitespace names
      if (this.username.trim().length === 0) {
        this.errorMsg = "No blank names !";
        ok = false;
      }

      // No special characters
      const regex = /[^\sa-zA-Z0-9]/;
      if (regex.test(this.username)) {
        this.errorMsg = "No special characters !";
        ok = false;
      }

      // Max name length is 20
      if (this.username.length > 20) {
        this.errorMsg = "Name length > 20 !";
        ok = false;
      }

      return ok;
    },
    createGameId() {
      this.gameId = nanoid();
      const db = this.$store.state.db;
      db.ref("/lobby/" + this.lobbyId).set({
        gameId: this.gameId,
      });
      const updates = {};
      const query = "/lobby/" + this.lobbyId + "/" + this.gameId;
      updates[query] = { id: this.gameId };
      db.ref().update(updates);
    },
    async createGameState() {
      await axios.post("/api/game/create", {
        lobbyId: this.lobbyId,
        gameId: this.gameId,
      });
    },
    async createGame() {
      this.createGameId();
      await this.createGameState();
    },
    assignRoles() {
      const redSpyMasterIndex = Math.floor(
        Math.random() * this.redTeamPlayers.length
      );
      const blueSpyMasterIndex = Math.floor(
        Math.random() * this.blueTeamPlayers.length
      );
      const redSpyMasterId = this.redTeamPlayers[redSpyMasterIndex].id;
      const blueSpyMasterId = this.blueTeamPlayers[blueSpyMasterIndex].id;
      const db = this.$store.state.db;
      const redQuery =
        "/lobby/" +
        this.lobbyId +
        "/players/" +
        redSpyMasterId +
        "/isSpyMaster";
      const blueQuery =
        "/lobby/" +
        this.lobbyId +
        "/players/" +
        blueSpyMasterId +
        "/isSpyMaster";
      const updates = {};
      updates[redQuery] = true;
      updates[blueQuery] = true;
      db.ref().update(updates);
    },
    async start() {
      if (!this.allReady) {
        this.errorMsg = "Waiting for all players to be ready...";
        return;
      }

      if (this.players.length < 4) {
        this.errorMsg = "Need 4 or more players to start a game";
        return;
      }

      if (this.allReady && this.players.length >= 4) {
        this.assignRoles();
        await this.createGame();
      }
    },
    initDbListeners() {
      this.initPlayersListener();
      this.initGameIdListener();
    },
    initGameIdListener() {
      const db = this.$store.state.db;
      const ref = db.ref("/lobby/" + this.lobbyId + "/gameId");
      this.gameIdListener.ref = ref;
      this.gameIdListener.listener = ref.on("value", (snapshot) => {
        const gameId = snapshot.val();
        if (gameId) {
          this.$store.commit("setGameId", snapshot.val());
          this.$router.push("/game");
        }
      });
    },
    initPlayersListener() {
      const db = this.$store.state.db;
      const ref = db.ref("/lobby/" + this.lobbyId + "/players");
      this.playersListener.ref = ref;
      this.playersListener.listener = ref.on("value", (snapshot) => {
        const players = snapshot.val();
        const dbPlayerIds = [];
        for (const id in players) {
          const player = players[id];
          dbPlayerIds.push(player.id);
        }
        const deadPlayers = this.players.filter((x) => {
          return dbPlayerIds.includes(x.id);
        });
        this.$store.commit("removePlayers", deadPlayers);

        for (const id in players) {
          const player = players[id];
          const existingPlayer = this.players.find((x) => x.id === player.id);
          if (!existingPlayer) {
            this.$store.commit("addPlayer", player);
            this.initPlayerIdListener(player.id);
          }
          if (player.id === this.playerId) {
            this.$store.commit("setPlayer", player);
          }
        }
      });
    },
    initPlayerIdListener(playerId) {
      const idListener = {
        ref: {},
        listener: {},
      };
      const db = this.$store.state.db;
      const ref = db.ref("/lobby/" + this.lobbyId + "/players/" + playerId);
      idListener.ref = ref;
      idListener.listener = ref.on("value", (snapshot) => {
        const playerInfo = snapshot.val();
        if (playerInfo) {
          this.$store.commit("updatePlayer", playerInfo);
        }
      });
      this.playerIdListeners.push(idListener);
    },
    addDummy() {
      const db = this.$store.state.db;
      const dummyId = nanoid();
      const update = "/lobby/" + this.lobbyId + "/players/" + dummyId;
      const updates = {};
      updates[update] = {
        id: dummyId,
        name: "fake name",
        team: "red",
      };
      db.ref().update(updates);
    },
    initWriteAnimations() {
      for (const key in this.typewriter) {
        const object = this.typewriter[key];
        animateWrite(object);
      }
    },
    disconnect() {
      const db = this.$store.state.db;
      const myPlayerRef = db.ref(
        "/lobby/" + this.lobbyId + "/players/" + this.playerId
      );
      myPlayerRef.remove();
    },
  },
  mounted() {
    this.lobbyId = this.$store.state.lobbyId;
    if (!this.lobbyId) {
      this.$store.commit("resetState");
      this.$router.push("/");
    }
    this.playerId = nanoid();
    this.initDbListeners();
    this.initWriteAnimations();

    window.y = this
    window.addEventListener("beforeunload", (_e) => {
      this.disconnect();
    });
  },
  beforeDestroy() {
    this.disconnect();    
    this.gameIdListener.ref.off("value", this.gameIdListener.listener);    
    this.playersListener.ref.off("value", this.playersListener.listener);
    this.playerIdListeners.forEach((refListener) => {
      refListener.ref.off("value", refListener.listener);
    });
  },
};
</script>

<style lang='sass' scoped>
.lobby
  background-image: radial-gradient(orange, red, purple)
  width: 100%
  height: 100%

.content
  padding-top: 20px
  max-width: 1080px
  width: 100%
  margin: auto

.header
  font-family: 'Courier'
  font-size: 36px
  font-weight: bold

.desc
  padding-left: 20px
  font-family: 'Courier'
  font-size: 16px
  font-weight: normal

.main-container
  display: flex
  padding-top: 20px
  max-width: 900px
  margin: auto
  align-items: center

.red-container
  background-color: rgba(189, 13, 57, 0.5)
  width: 300px
  min-height: 600px

.blue-container
  background-color: rgba(3, 43, 173, 0.5)
  width: 300px
  min-height: 600px

.middle-container
  display: flex
  flex-direction: column
  width: 300px
  min-height: 600px

.team-header
  display: flex
  justify-content: center
  align-items: center
  padding-top: 20px
  p
    color: white
    font-weight: bold
    font-size: 32px

.game-header
  display: flex
  justify-content: center
  align-items: center
  padding-top: 20px
  p
    color: black
    font-weight: bold
    font-size: 32px

.input-main-container
  padding-top: 30px

.input-header
  display: flex
  justify-content: center
  align-items: center
  p
    color: black
    font-size: 24px

.input-main-container
  flex-grow: 1

.input-container
  position: relative
  padding-top: 20px

#name-input
  background: transparent
  color: #fff
  border: 1px solid #fff
  width: 85%
  height: 35px
  text-align: center
  border-radius: 20px
  outline: none

.floating-text
  position: absolute
  bottom: -20px
  right: 20px
  color: #fff

.start-container
  width: 150px
  margin: auto
  cursor: pointer
  position: relative
  transition: transform 0.5s ease-in, filter 0.5s ease-in

.has-hover  
  transition: transform 0.5s ease-in, filter 0.5s ease-in
.has-hover:hover
  transform: translateY(-10px)
  filter: drop-shadow(0px 0px 5px #fff) drop-shadow(0px 0px 5px #fff) 

img
  width: 100%

.hover-bg
  position: absolute
  z-index: 150
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  width: 160px
  height: 160px
  border-radius: 50%
  background-color: rgba(252, 248, 3, 0.5)

.start-text
  position: absolute
  z-index: 100
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  background-color: rgba(0, 0, 0, 0.8)
  p
    font-size: 24px
    color: white
    font-weight: bold

.error-msg
  padding: 40px 20px 20px 20px
  color: white

.team-member
  padding: 10px 20px
  text-align: center
  color: #fff
  position: relative
  display: flex
  justify-content: center
  align-items: center

.ready-container
  flex-grow: 1
  padding: 30px 20px

.select-team
  display: flex
  justify-content: center
  width: 100%
  background-color: rgba(0, 0, 0, 0.7)
  border: 1px solid #fff
  cursor: pointer

.select-red-team
  flex-grow: 1
  width: 50%
  height: 40px
  display: flex
  justify-content: center
  align-items: center
  color: red
  padding: 10px 0px
  border-right: 1px solid #fff

.select-blue-team
  flex-grow: 1
  width: 50%
  display: flex
  height: 40px
  justify-content: center
  align-items: center
  color: blue
  padding: 10px 0px

.ready
  width: 100%
  height: 40px
  background-color: rgba(0, 0, 0, 0.7)
  border: 1px solid #fff
  border-top: none
  padding: 10px 0px
  display: flex
  justify-content: center
  align-items: center
  color: white
  cursor: pointer

.change-name
  width: 100%
  height: 40px
  background-color: rgba(0, 0, 0, 0.7)
  border: 1px solid #fff
  border-top: none
  padding: 10px 0px
  display: flex
  justify-content: center
  align-items: center
  color: white
  cursor: pointer

.ready-check
  width: 20px
  height: 20px
  margin-left: 20px
  img
    width: 100%

.cancel-ready-container  
  padding: 30px 20px

.cancel-ready
  width: 100%
  height: 40px
  background-color: rgba(0, 0, 0, 0.7)
  border: 1px solid #fff  
  padding: 10px 0px
  display: flex
  justify-content: center
  align-items: center
  color: white
  cursor: pointer

.you
  font-style: italic  
  font-family: 'Courier'

.typing-demo 
  width: 22ch
  animation: typing 1s
  animation-timing-function: steps(22)
  white-space: nowrap
  overflow: hidden    

@keyframes typing
  0%
    width: 0

.type-join-blue    
  width: 9ch
  animation-timing-function: steps(9)

.type-join-red
  width: 8ch
  animation-timing-function: steps(8)

.type-ready
  width: 5ch
  animation-timing-function: steps(5)

.type-cancel  
  width: 6ch
  animation-timing-function: steps(6)  

.type-start
  width: 5ch
  animation-timing-function: steps(5)  

.type-blue-team  
  width: 9ch
  animation-timing-function: steps(9)  

.type-red-team
  width: 8ch
  animation-timing-function: steps(8)  

.type-codenames
  width: 9ch
  animation-timing-function: steps(9)  

.type-lobby  
  width: 5ch
  animation-timing-function: steps(5)  

.lobby-text  
  display: flex
  justify-content: center
  align-items: center
</style>
